var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvanceTva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.5,
    height: 88.531,
    viewBox: "0 0 88.5 88.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_335",
    x: 0,
    y: 0,
    width: 88.5,
    height: 88.531,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_336",
    x: 27.395,
    y: 9.197,
    width: 28.333,
    height: 31.103,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_337",
    x: 17.091,
    y: 28.368,
    width: 44.329,
    height: 20.761,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_338",
    x: 15.522,
    y: 9.098,
    width: 29.205,
    height: 31.199,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_339",
    x: 39.688,
    y: 9.081,
    width: 26.405,
    height: 31.214,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_340",
    x: 17.093,
    y: 36.08,
    width: 34.99,
    height: 20.759,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_341",
    x: 17.09,
    y: 43.786,
    width: 34.998,
    height: 20.766,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_342",
    x: 22.184,
    y: 51.502,
    width: 29.906,
    height: 20.763,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_343",
    x: 53.444,
    y: 24.268,
    width: 20.734,
    height: 20.727,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_344",
    x: 17.091,
    y: 51.517,
    width: 20.731,
    height: 20.732,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_345",
    x: 47.633,
    y: 38.636,
    width: 28.833,
    height: 35.115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_346",
    x: 44.249,
    y: 36.204,
    width: 26.243,
    height: 26.246,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_347",
    x: 55.36,
    y: 48.371,
    width: 26.252,
    height: 26.245,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_260",
    "data-name": "Groupe 260",
    transform: "translate(2856.2 1100.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_335-2",
    "data-name": "Trac\\xE9 335",
    d: "M-2784.126-1094.4a19.3,19.3,0,0,1,2.761.962,8.285,8.285,0,0,1,4.657,7.21c.079,1.191-.478,1.739-1.682,1.741q-5.887.008-11.774,0h-.848v.76q0,4.785,0,9.571c0,.9-.343,1.457-.975,1.636a1.382,1.382,0,0,1-1.771-1.449c-.023-1.56-.007-3.121-.007-4.682,0-1.905.055-3.812-.013-5.714a9.581,9.581,0,0,1,2.253-7.244c-.314-.018-.507-.038-.7-.038q-19.176,0-38.351,0a6.078,6.078,0,0,0-6.427,6.305q-.017,25.372,0,50.745v.514h29.669c1.547,0,1.912.335,2.018,1.849a5.821,5.821,0,0,0,4.618,5.458,5.743,5.743,0,0,0,6.463-3.4c.147-.331.233-.69.372-1.109-.761-.1-1.477-.179-2.187-.29a16.742,16.742,0,0,1-13.63-13.078,16.793,16.793,0,0,1,7.411-17.384,16.374,16.374,0,0,1,19.391,1.14,15.867,15.867,0,0,1,5.975,15.354,16.429,16.429,0,0,1-13.6,13.948c-.34.063-.565.146-.642.563a8.479,8.479,0,0,1-8.579,7.14q-11.911.017-23.823,0c-4.774,0-9.549-.068-14.321.018a8.89,8.89,0,0,1-9.22-7.562c-.007-.059-.069-.112-.1-.168v-1.515a1.936,1.936,0,0,1,1.951-.977c1.806.042,3.613.013,5.486.013v-.942q0-24.958,0-49.916c0-.3,0-.6.008-.895a8.811,8.811,0,0,1,6.728-8.305c.327-.08.651-.174.977-.262Zm4.68,46.435a13.953,13.953,0,0,0-13.847-13.932,13.955,13.955,0,0,0-13.967,13.882,13.954,13.954,0,0,0,13.848,13.932A13.954,13.954,0,0,0-2779.446-1047.965Zm-64.775,16.664c.035.177.051.334.1.482a6.088,6.088,0,0,0,6.067,4.173q15.759.007,31.518,0c.193,0,.386-.02.688-.036a8.979,8.979,0,0,1-2.157-4.619Zm64.511-55.965c-.3-2.313-2.819-4.33-5.444-4.375a5.665,5.665,0,0,0-5.6,4.375Z",
    transform: "translate(2856.2 1100.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_336-2",
    "data-name": "Trac\\xE9 336",
    d: "M-2682.89-1029.485a9.55,9.55,0,0,1-.963-.005c-.792-.081-1.432-.031-1.738.926a1.176,1.176,0,0,1-1.505.625,1.3,1.3,0,0,1-.963-1.4,2.563,2.563,0,0,1,.154-.665q1.793-4.9,3.6-9.8a1.473,1.473,0,0,1,1.224-1.15c.754-.084,1.247.255,1.573,1.136q1.7,4.606,3.387,9.218a7.961,7.961,0,0,1,.365,1.107,1.332,1.332,0,0,1-.871,1.534,1.194,1.194,0,0,1-1.617-.633c-.28-.913-.86-.966-1.61-.893C-2682.2-1029.458-2682.546-1029.485-2682.89-1029.485Zm1.222-2.783-1.238-3.355-1.229,3.355Z",
    transform: "translate(2724.46 1056.17)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_337-2",
    "data-name": "Trac\\xE9 337",
    d: "M-2734.766-926.855h-11.22a5.56,5.56,0,0,1-.619-.013,1.4,1.4,0,0,1-1.313-1.35,1.4,1.4,0,0,1,1.287-1.374,4.434,4.434,0,0,1,.55-.016h22.647c.138,0,.276-.006.413,0a1.372,1.372,0,0,1,1.431,1.362A1.363,1.363,0,0,1-2723-926.86c-.32.02-.642.005-.963.005Z",
    transform: "translate(2774.01 963.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_338-2",
    "data-name": "Trac\\xE9 338",
    d: "M-2751.412-1033.39c.955-2.339,1.863-4.563,2.773-6.786.48-1.174,1.145-1.6,1.979-1.263q1.289.515.577,2.273-1.94,4.772-3.885,9.543c-.052.127-.1.256-.157.381a1.359,1.359,0,0,1-1.275.892,1.307,1.307,0,0,1-1.29-.864q-2.123-5.18-4.217-10.373a1.342,1.342,0,0,1,.705-1.842,1.347,1.347,0,0,1,1.833.846c.886,2.111,1.738,4.237,2.6,6.356C-2751.669-1034-2751.57-1033.765-2751.412-1033.39Z",
    transform: "translate(2781.56 1056.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_339-2",
    "data-name": "Trac\\xE9 339",
    d: "M-2611.051-1038.885c0,2.868,0,5.639,0,8.409a4.813,4.813,0,0,1-.042.821,1.385,1.385,0,0,1-1.421,1.219,1.388,1.388,0,0,1-1.281-1.371c-.014-.205-.009-.412-.009-.618q0-3.815,0-7.63v-.829c-.484,0-.911.013-1.338,0a1.42,1.42,0,0,1-1.509-1.367,1.405,1.405,0,0,1,1.5-1.376q2.715-.03,5.43,0a1.353,1.353,0,0,1,1.476,1.377,1.366,1.366,0,0,1-1.489,1.366C-2610.145-1038.873-2610.553-1038.885-2611.051-1038.885Z",
    transform: "translate(2665.34 1056.73)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_340)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_340-2",
    "data-name": "Trac\\xE9 340",
    d: "M-2739.4-882.053c-2.316,0-4.632.012-6.947-.005a1.372,1.372,0,0,1-1.452-1.853,1.427,1.427,0,0,1,1.482-.9h4.54q4.608,0,9.217,0c1.074,0,1.723.606,1.639,1.491-.074.792-.643,1.254-1.6,1.258C-2734.819-882.047-2737.111-882.052-2739.4-882.053Z",
    transform: "translate(2774 926.89)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_341-2",
    "data-name": "Trac\\xE9 341",
    d: "M-2739.47-837.284c-2.293,0-4.586.012-6.879,0-1.172-.008-1.877-.948-1.452-1.9a1.518,1.518,0,0,1,1.585-.85c3.3.008,6.6,0,9.905,0,1.307,0,2.615-.022,3.921.008a1.366,1.366,0,0,1,1.388,1.806,1.467,1.467,0,0,1-1.59.938C-2734.884-837.28-2737.177-837.283-2739.47-837.284Z",
    transform: "translate(2774.01 889.83)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_342-2",
    "data-name": "Trac\\xE9 342",
    d: "M-2712.35-792.464c-1.467,0-2.935.01-4.4,0a1.423,1.423,0,0,1-1.568-1.229,1.348,1.348,0,0,1,1.348-1.5q4.608-.044,9.216,0a1.327,1.327,0,0,1,1.332,1.385,1.367,1.367,0,0,1-1.455,1.342C-2709.369-792.446-2710.86-792.464-2712.35-792.464Z",
    transform: "translate(2749.51 852.72)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_343-2",
    "data-name": "Trac\\xE9 343",
    d: "M-2535.406-953.427a1.421,1.421,0,0,1,1.4,1.339,1.388,1.388,0,0,1-1.334,1.387,1.388,1.388,0,0,1-1.4-1.325A1.426,1.426,0,0,1-2535.406-953.427Z",
    transform: "translate(2599.19 983.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_344-2",
    "data-name": "Trac\\xE9 344",
    d: "M-2746.524-792.4a1.419,1.419,0,0,1-1.393-1.34,1.421,1.421,0,0,1,1.341-1.392,1.415,1.415,0,0,1,1.39,1.34A1.415,1.415,0,0,1-2746.524-792.4Z",
    transform: "translate(2774.01 852.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_345-2",
    "data-name": "Trac\\xE9 345",
    d: "M-2559.667-868.431a5.266,5.266,0,0,1-.305.755q-3.924,6.974-7.865,13.938a1.4,1.4,0,0,1-1.947.723,1.378,1.378,0,0,1-.464-2.028q3.967-7.068,7.969-14.116a1.358,1.358,0,0,1,1.68-.724A1.427,1.427,0,0,1-2559.667-868.431Z",
    transform: "translate(2627.13 914.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_346-2",
    "data-name": "Trac\\xE9 346",
    d: "M-2586.03-884.09a4.112,4.112,0,0,1,4.116,4.094,4.144,4.144,0,0,1-4.145,4.151,4.178,4.178,0,0,1-4.1-4.146A4.144,4.144,0,0,1-2586.03-884.09Zm.026,2.758A1.379,1.379,0,0,0-2587.39-880a1.4,1.4,0,0,0,1.341,1.388,1.375,1.375,0,0,0,1.374-1.342A1.35,1.35,0,0,0-2586-881.332Z",
    transform: "translate(2643.41 926.29)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2856.2, -1100.4)",
    filter: "url(#Trac\\xE9_347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_347-2",
    "data-name": "Trac\\xE9 347",
    d: "M-2521.487-805.166a4.124,4.124,0,0,1-4.125-4.093,4.165,4.165,0,0,1,4.153-4.151,4.184,4.184,0,0,1,4.1,4.145A4.143,4.143,0,0,1-2521.487-805.166Zm-.049-2.759a1.387,1.387,0,0,0,1.412-1.309,1.413,1.413,0,0,0-1.323-1.409,1.4,1.4,0,0,0-1.406,1.32A1.373,1.373,0,0,0-2521.535-807.925Z",
    transform: "translate(2589.97 867.78)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvanceTva);
export default __webpack_public_path__ + "static/media/avance-tva.00d5698ec4f8bc727a8162d17ac0b308.svg";
export { ForwardRef as ReactComponent };